module.exports = __webpack_public_path__ + "img/confetti_2a.eba02a79.svg";